import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import ImagesUpload from '../Images-Upload/Images-Upload';

const InsertCarrossel = (props) => {
    const { isOpen, toggle, handleModalCarrossel, imagensIniciais, editando } = props;

    const [imagens, setImagens] = useState([]);
    const [openModalImagem, setOpenModalImagem] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setImagens(imagensIniciais || []);
        } else {
            setOpenModalImagem(false);
        }
    }, [isOpen]);

    const toggleModalImagem = () => setOpenModalImagem(aberto => !aberto);

    const onChangeInput = (e) => {
        const { value, alt } = e.target;
        setImagens(imgs => [...imgs, { src: value, alt: alt || '' }]);
    };

    const removeImagem = (index) => {
        setImagens(imgs => imgs.filter((_, i) => i !== index));
    };

    const moveImagem = (index, direcao) => {
        setImagens(imgs => {
            const alvo = index + direcao;
            if (alvo < 0 || alvo >= imgs.length) return imgs;
            const novo = [...imgs];
            [novo[index], novo[alvo]] = [novo[alvo], novo[index]];
            return novo;
        });
    };

    return (
        <Modal size="lg" isOpen={isOpen} toggle={toggle} returnFocusAfterClose={false}>
            <ModalHeader toggle={toggle}>{editando ? 'Editar carrossel de imagens' : 'Inserir carrossel de imagens'}</ModalHeader>
            <ModalBody>
                <div className="row no-gutters">
                    <div className="col-12 py-2">
                        <button className="btn btn-outline-secondary" onClick={toggleModalImagem}>+ adicionar imagem</button>
                    </div>
                    {imagens.length > 0 && (
                        <div className="col-12">
                            <div className="row">
                                {imagens.map((img, index) => (
                                    <div key={`carrossel-img-${index}`} className="col-3 px-2 py-2 text-center">
                                        <img className="w-100 img-fluid" src={img.src} alt={img.alt} />
                                        <p className="m-0 text-truncate"><small>{img.alt}</small></p>
                                        <div className="row no-gutters py-2">
                                            <div className="col-4">
                                                <button className="btn btn-sm btn-outline-secondary" disabled={index === 0} onClick={() => moveImagem(index, -1)}>◀</button>
                                            </div>
                                            <div className="col-4">
                                                <button className="btn btn-sm btn-outline-secondary" disabled={index === imagens.length - 1} onClick={() => moveImagem(index, 1)}>▶</button>
                                            </div>
                                            <div className="col-4">
                                                <button className="btn btn-sm btn-outline-danger" onClick={() => removeImagem(index)}>x</button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    {imagens.length < 2 && (
                        <div className="col-12 py-2">
                            <small className="text-danger">Adicione ao menos 2 imagens para formar um carrossel.</small>
                        </div>
                    )}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="success" disabled={imagens.length < 2} onClick={() => handleModalCarrossel(imagens)}>{editando ? 'salvar alterações' : 'inserir carrossel'}</Button>
            </ModalFooter>

            <Modal size="lg" isOpen={openModalImagem} toggle={toggleModalImagem} zIndex={1060}>
                <ModalHeader toggle={toggleModalImagem}>Adicionar imagem ao carrossel</ModalHeader>
                <ModalBody>
                    <ImagesUpload
                        toggle={toggleModalImagem}
                        onChangeInput={onChangeInput}
                        imgNoTexto={true}
                        alteracao={true}
                    />
                </ModalBody>
            </Modal>
        </Modal>
    );
};

export default InsertCarrossel;
